// Lib
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, RadioGroup, Radio as ChakraRadio, Stack, HStack } from "@chakra-ui/react"

export default function Radio({ label, value, helper, error, placeholder, options = [], ...props}){
    return(
    <FormControl isInvalid={!!error}>
        { label && <FormLabel fontSize="sm" children={label} /> }
        <RadioGroup value={value} {...props}>
        <HStack spacing={4}>{options?.map(item => <ChakraRadio key={item?.value} value={item?.value}>{item?.label}</ChakraRadio>)}</HStack></RadioGroup>
        { !!error && <FormErrorMessage children={error} /> }
        { (!error && !!helper) && <FormHelperText children={helper} />}
    </FormControl>
    )
}
